import React from 'react'

const AugmentIconWithFallback = ({ alt, format, individualStats, matchRecord, src, width, height }) => {

    // if (src.includes("/0.png")){ // Empty, not missing
    //     src = process.env.PUBLIC_URL + `/assets/empty_icons/0.png`
    // }

    if (src.includes("/0.png")) { // Empty, not missing
        // src = process.env.PUBLIC_URL + `/assets/empty_icons/0.png`
        // return (<div className={`w-[${width}px] h-[${height}px] min-w-[${height}px] rounded-md ${(matchRecord?.archived_match_json?.info?.endOfGameResult === "Abort_Unexpected" || individualStats?.gameEndedInEarlySurrender) ? "bg-gray-700" : individualStats?.win ? "bg-cyan-900" : "bg-rose-950"}`}></div>)
        return (<div className={`${format} w-[${width + "px"}] h-[${height + "px"}] min-w-[${width + "px"}] rounded-md ${(matchRecord?.archived_match_json?.info?.endOfGameResult === "Abort_Unexpected" || individualStats?.gameEndedInEarlySurrender) ? "bg-gray-700" : individualStats?.win ? "bg-cyan-900" : "bg-rose-950"}`}></div>)
    }

    function handleError(e) {
        // e.target.src = process.env.PUBLIC_URL + `/assets/profile_icons/0.png`
        e.target.src = process.env.PUBLIC_URL + `/assets/missing_asset/missing_icon.png`
    }
    return (
        <img
            className={`rounded-md ${format} ${(matchRecord?.archived_match_json?.info?.endOfGameResult === "Abort_Unexpected" || individualStats?.gameEndedInEarlySurrender) ? "bg-gray-700" : individualStats?.win ? "bg-cyan-900" : "bg-rose-950"}`}
            width={width}
            height={height}
            src={src}
            alt={alt}
            onError={(e) => handleError(e)}
        />
    )
}

export default AugmentIconWithFallback
